import { Countries } from './Countries';

export interface ICountryCode {
    name: string;
    name_fr: string;
    name_en: string;
    dial_code: string;
    code: string;
    currency: string;
    currencySymbol: string;
    locale: string;
    annualAmount: number;
    amountMin: number;
    amountMax: number;
    companyNumberMinLength: number;
    companyNumberMaxLength: number;
}

export const CountryCodes: ICountryCode[] = [
    {
        name: 'France',
        name_fr: 'France',
        name_en: 'France',
        dial_code: '+33',
        code: Countries.France,
        currency: 'EUR',
        currencySymbol: '€',
        locale: 'fr-FR',
        annualAmount: 37500,
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 14,
        companyNumberMaxLength: 14,
    },
    {
        name: 'Belgique',
        name_fr: 'Belgique',
        name_en: 'Belgium',
        dial_code: '+32',
        code: Countries.Belgium,
        currency: 'EUR',
        currencySymbol: '€',
        locale: 'fr-BE',
        annualAmount: 25000,
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 10,
        companyNumberMaxLength: 15,
    },
    {
        name: 'Royaume Uni',
        name_fr: 'Royaume Uni',
        name_en: 'United Kingdom',
        dial_code: '+44',
        code: Countries.UnitedKingdom,
        currency: 'GBP',
        currencySymbol: '£',
        locale: 'en-GB',
        annualAmount: 85000,
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 5,
        companyNumberMaxLength: 17,
    },
    {
        code: Countries.Germany,
        name: 'Allemagne',
        dial_code: '+49',
        locale: 'en-DE',
        currencySymbol: '€',
        currency: 'EUR',
        annualAmount: 33200,
        name_fr: 'Allemagne',
        name_en: 'Germany',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 6,
        companyNumberMaxLength: 30,
    },
    {
        code: 'AR',
        name: 'Argentine',
        dial_code: '+54',
        locale: 'en-AR',
        currencySymbol: '$',
        currency: 'ARS',
        annualAmount: 33200,
        name_fr: 'Argentine',
        name_en: 'Argentina',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 0,
        companyNumberMaxLength: 30,
    },
    {
        code: 'AU',
        name: 'Australie',
        dial_code: '+61',
        locale: 'en-AU',
        currencySymbol: '$',
        currency: 'AUD',
        annualAmount: 33200,
        name_fr: 'Australie',
        name_en: 'Australia',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 0,
        companyNumberMaxLength: 30,
    },
    {
        code: 'AT',
        name: 'Autriche',
        dial_code: '+43',
        locale: 'en-AT',
        currencySymbol: '€',
        currency: 'EUR',
        annualAmount: 33200,
        name_fr: 'Autriche',
        name_en: 'Austria',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 0,
        companyNumberMaxLength: 30,
    },
    {
        code: 'BR',
        name: 'Brésil',
        dial_code: '+55',
        locale: 'en-BR',
        currencySymbol: 'R$',
        currency: 'BRL',
        annualAmount: 33200,
        name_fr: 'Brésil',
        name_en: 'Brasil',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 0,
        companyNumberMaxLength: 30,
    },
    {
        code: 'CO',
        name: 'Colombie',
        dial_code: '+57',
        locale: 'en-CO',
        currencySymbol: '$',
        currency: 'COP',
        annualAmount: 33200,
        name_fr: 'Colombie',
        name_en: 'Colombia',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 0,
        companyNumberMaxLength: 30,
    },
    {
        code: 'DK',
        name: 'Danemark',
        dial_code: '+45',
        locale: 'en-DK',
        currencySymbol: 'kr',
        currency: 'DKK',
        annualAmount: 33200,
        name_fr: 'Danemark',
        name_en: 'Denmark',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 0,
        companyNumberMaxLength: 30,
    },
    {
        code: 'ES',
        name: 'Espagne',
        dial_code: '+34',
        locale: 'en-ES',
        currencySymbol: '€',
        currency: 'EUR',
        annualAmount: 33200,
        name_fr: 'Espagne',
        name_en: 'Spain',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 0,
        companyNumberMaxLength: 30,
    },
    {
        code: Countries.UnitedStates,
        name: 'Etats-Unis',
        dial_code: '+1',
        locale: 'en-US',
        currencySymbol: '$',
        currency: 'USD',
        annualAmount: 33200,
        name_fr: 'Etats-Unis',
        name_en: 'USA',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 4,
        companyNumberMaxLength: 30,
    },
    {
        code: 'FI',
        name: 'Finlande',
        dial_code: '+358',
        locale: 'en-FI',
        currencySymbol: '€',
        currency: 'EUR',
        annualAmount: 33200,
        name_fr: 'Finlande',
        name_en: 'Finland',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 0,
        companyNumberMaxLength: 30,
    },
    {
        code: 'GP',
        name: 'Guadeloupe',
        dial_code: '+590',
        locale: 'fr-GP',
        currencySymbol: '€',
        currency: 'EUR',
        annualAmount: 33200,
        name_fr: 'Guadeloupe',
        name_en: 'Guadeloupe',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 0,
        companyNumberMaxLength: 30,
    },
    {
        code: 'HK',
        name: 'Hong Kong',
        dial_code: '+852',
        locale: 'en-HK',
        currencySymbol: '$',
        currency: 'HKD',
        annualAmount: 33200,
        name_fr: 'Hong Kong',
        name_en: 'Hong Kong',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 0,
        companyNumberMaxLength: 30,
    },
    {
        code: Countries.Ireland,
        name: 'Irlande',
        dial_code: '+353',
        locale: 'en-IE',
        currencySymbol: '€',
        currency: 'EUR',
        annualAmount: 33200,
        name_fr: 'Irlande',
        name_en: 'Ireland',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 0,
        companyNumberMaxLength: 30,
    },
    {
        code: 'IL',
        name: 'Israël',
        dial_code: '+972',
        locale: 'fr-IL',
        currencySymbol: '₪',
        currency: 'ILS',
        annualAmount: 33200,
        name_fr: 'Israël',
        name_en: 'Israel',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 0,
        companyNumberMaxLength: 30,
    },
    {
        code: Countries.Italy,
        name: 'Italie',
        dial_code: '+39',
        locale: 'en-IT',
        currencySymbol: '€',
        currency: 'EUR',
        annualAmount: 33200,
        name_fr: 'Italie',
        name_en: 'Italy',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 0,
        companyNumberMaxLength: 30,
    },
    {
        code: 'JP',
        name: 'Japon',
        dial_code: '+81',
        locale: 'en-JP',
        currencySymbol: '¥',
        currency: 'JPY',
        annualAmount: 33200,
        name_fr: 'Japon',
        name_en: 'Japan',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 0,
        companyNumberMaxLength: 30,
    },
    {
        code: 'LB',
        name: 'Liban',
        dial_code: '+961',
        locale: 'en-LB',
        currencySymbol: '£',
        currency: 'LBP',
        annualAmount: 33200,
        name_fr: 'Liban',
        name_en: 'Lebanon',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 0,
        companyNumberMaxLength: 30,
    },
    {
        code: Countries.Luxembourg,
        name: 'Luxembourg',
        dial_code: '+352',
        locale: 'fr-LU',
        currencySymbol: '€',
        currency: 'EUR',
        annualAmount: 33200,
        name_fr: 'Luxembourg',
        name_en: 'Luxemburg',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 7,
        companyNumberMaxLength: 7,
    },
    {
        code: 'MQ',
        name: 'Martinique',
        dial_code: '+596',
        locale: 'fr-MQ',
        currencySymbol: '€',
        currency: 'EUR',
        annualAmount: 33200,
        name_fr: 'Martinique',
        name_en: 'Martinique',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 0,
        companyNumberMaxLength: 30,
    },
    {
        code: 'MX',
        name: 'Mexique',
        dial_code: '+52',
        locale: 'en-MX',
        currencySymbol: '$',
        currency: 'MXN',
        annualAmount: 33200,
        name_fr: 'Mexique',
        name_en: 'Mexico',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 0,
        companyNumberMaxLength: 30,
    },
    {
        code: 'MC',
        name: 'Monaco',
        dial_code: '+377',
        locale: 'fr-MC',
        currencySymbol: '€',
        currency: 'EUR',
        annualAmount: 33200,
        name_fr: 'Monaco',
        name_en: 'Monaco',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 0,
        companyNumberMaxLength: 30,
    },
    {
        code: 'NO',
        name: 'Norvège',
        dial_code: '+47',
        locale: 'en-NO',
        currencySymbol: '€',
        currency: 'EUR',
        annualAmount: 33200,
        name_fr: 'Norvège',
        name_en: 'Norway',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 0,
        companyNumberMaxLength: 30,
    },
    {
        code: Countries.Netherlands,
        name: 'Pays-Bas',
        dial_code: '+31',
        locale: 'en-NL',
        currencySymbol: '€',
        currency: 'EUR',
        annualAmount: 33200,
        name_fr: 'Pays-Bas',
        name_en: 'Netherlands',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 8,
        companyNumberMaxLength: 8,
    },
    {
        code: 'PF',
        name: 'Polynésie française',
        dial_code: '+689',
        locale: 'fr-PF',
        currencySymbol: 'F',
        currency: 'XPF',
        annualAmount: 33200,
        name_fr: 'Polynésie française',
        name_en: 'French Polynesia',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 0,
        companyNumberMaxLength: 30,
    },
    {
        code: 'PT',
        name: 'Portugal',
        dial_code: '+351',
        locale: 'en-PT',
        currencySymbol: '€',
        currency: 'EUR',
        annualAmount: 33200,
        name_fr: 'Portugal',
        name_en: 'Portugal',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 0,
        companyNumberMaxLength: 30,
    },
    {
        code: 'RE',
        name: 'La Réunion',
        dial_code: '+262',
        locale: 'fr-Re',
        currencySymbol: '€',
        currency: 'EUR',
        annualAmount: 33200,
        name_fr: 'La Réunion',
        name_en: 'La Réunion',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 0,
        companyNumberMaxLength: 30,
    },
    {
        code: Countries.Romania,
        name: 'Roumanie',
        dial_code: '+40',
        locale: 'ro_RO',
        currencySymbol: '€',
        currency: 'EUR',
        annualAmount: 33200,
        name_fr: 'Roumanie',
        name_en: 'Romania',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 9,
        companyNumberMaxLength: 18,
    },
    {
        code: 'RU',
        name: 'Russie',
        dial_code: '+495',
        locale: 'en-RU',
        currencySymbol: '₽',
        currency: 'RUB',
        annualAmount: 33200,
        name_fr: 'Russie',
        name_en: 'Russia',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 0,
        companyNumberMaxLength: 30,
    },
    {
        code: 'SG',
        name: 'Singapour',
        dial_code: '+65',
        locale: 'en-SG',
        currencySymbol: '$',
        currency: 'SGD',
        annualAmount: 33200,
        name_fr: 'Singapour',
        name_en: 'Singapour',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 0,
        companyNumberMaxLength: 30,
    },
    {
        code: 'SE',
        name: 'Suède',
        dial_code: '+46',
        locale: 'en-SE',
        currencySymbol: '€',
        currency: 'EUR',
        annualAmount: 33200,
        name_fr: 'Suède',
        name_en: 'Sweden',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 0,
        companyNumberMaxLength: 30,
    },
    {
        code: Countries.Switzerland,
        name: 'Suisse',
        dial_code: '+41',
        locale: 'fr-CH',
        currencySymbol: 'CHF',
        currency: 'CHF',
        annualAmount: 33200,
        name_fr: 'Suisse',
        name_en: 'Switzerland',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 12,
        companyNumberMaxLength: 15,
    },
    {
        code: 'TR',
        name: 'Turquie',
        dial_code: '+90',
        locale: 'en-TR',
        currencySymbol: '₺',
        currency: 'TRL',
        annualAmount: 33200,
        name_fr: 'Turquie',
        name_en: 'Turkey',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 0,
        companyNumberMaxLength: 30,
    },
    {
        code: Countries.Cyprus,
        name: 'Chypre',
        dial_code: '+357',
        locale: 'en-CY',
        currencySymbol: '€',
        currency: 'EUR',
        annualAmount: 33200,
        name_fr: 'Chypre',
        name_en: 'Cyprus',
        amountMin: 100,
        amountMax: 5000,
        companyNumberMinLength: 9, // ΗΕ \d{6}
        companyNumberMaxLength: 9, // ΗΕ \d{6}
    },
];
